import React from 'react';
import type { IconComponentProps } from '@/types/components';

export const CameraChip: React.FC<IconComponentProps> = ({ className }) => (
  <svg
    className={className}
    width="32"
    height="28"
    viewBox="0 0 32 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="32" height="28" rx="14" fill="#F8F9FA" fillOpacity="0.8" />
    <path
      d="M16.0004 16.6665C17.0926 16.6665 17.978 15.7711 17.978 14.6665C17.978 13.5619 17.0926 12.6665 16.0004 12.6665C14.9082 12.6665 14.0228 13.5619 14.0228 14.6665C14.0228 15.7711 14.9082 16.6665 16.0004 16.6665Z"
      fill="#292C4B"
    />
    <path
      d="M21.2736 9.33333H19.184L18.3666 8.43333C18.1227 8.16 17.7667 8 17.3976 8H14.6026C14.2334 8 13.8774 8.16 13.6269 8.43333L12.8161 9.33333H10.7265C10.0014 9.33333 9.40808 9.93333 9.40808 10.6667V18.6667C9.40808 19.4 10.0014 20 10.7265 20H21.2736C21.9987 20 22.592 19.4 22.592 18.6667V10.6667C22.592 9.93333 21.9987 9.33333 21.2736 9.33333ZM16.0001 18C14.1807 18 12.7041 16.5067 12.7041 14.6667C12.7041 12.8267 14.1807 11.3333 16.0001 11.3333C17.8194 11.3333 19.296 12.8267 19.296 14.6667C19.296 16.5067 17.8194 18 16.0001 18Z"
      fill="#292C4B"
    />
  </svg>
);
